<template>
  <el-dialog title="移除区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <Title :isLine="false">移除区域</Title>
    <el-form ref="dataForm" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="" prop="childDetail">
        <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
          <el-cascader v-model="item.districtCode" :props="cascaderProps" collapse-tags :options="options.areaOptions" placeholder="请选择需要移除的区域" clearable></el-cascader>
          <el-select v-model="item.technicianInfoId" placeholder="请选择老师" clearable size="small" filterable :filter-method="technicalFilter" @blur="handleTechnical()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddCustomer"></i>
            <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'

function initFormBean() {
  const formBean = {
    childDetail: [{
      technicianInfoId: '',
      districtCode: ''
    }]
  }
  return formBean
}
export default {
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      options: {
        areaOptions: [],
        identityOptions: []
      },
      isLoading: false,
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      id: null,
      levelId: null,
      parentId: null
    }
  },
  methods: {
    technicalFilter(e) {
      this.handleTechnical(e)
    },
    // 获取技术老师
    handleTechnical(val) {
      let obj = {
        status: 10,
        pageNo: 1,
        pageSize: 100,
        realName: val,
        isGetAllParent: true,
      }
      //status  10 已入职  20  离职交接  30 已离职
      technicianInfoApi.listPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list.filter(i => i.id != this.id)
      })
    },
    // 获取地区
    changeIdentity() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      technicianAreaApi.fetchTreeList({
        techInfoId: this.id,
        parentTechInfoId: this.parentId,
        addOrDelete: 2,
        v: 3,
        customerLeveId: this.levelId
      }).then(({ data }) => {
        this.loading.close()
        this.options.areaOptions = this.formatCascaderData(data)
        this.formVisible = true
      }).catch(() => {
        this.loading.close()
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    cascaderData(data) {
      return data.reduce((data, item) => (data.push(...item.districtCode.map(id => ({ ...item, districtCode: id[2] }))), data), [])
    },
    handleDeleteCustomer(index) {
      if (this.form.childDetail.length <= 1) return
      this.form.childDetail.splice(index, 1)
    },
    handleAddCustomer() {
      this.form.childDetail.push({
        technicianInfoId: '',
        districtCode: ''
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.id = row.id
      this.levelId = row.levelId
      this.parentId = row.parentId
      this.resetForm()
      this.$nextTick(() => {
        this.handleTechnical()
        this.changeIdentity()
      })
    },
    doCreate() {
      this.isLoading = true
      // if(!arr.length) return this.$message.error('内容不能为空')
      let arr = this.cascaderData(this.form.childDetail)

      // console.log('this.form.childDetail: ',this.form.childDetail,arr);
      technicianAreaApi.makeTransfer({ id: this.id, detail: arr })
        .then(() => {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
          this.isLoading = false
        }).catch(res => {
          this.isLoading = false
        })

    }
  }
}
</script>
<style lang="scss" scoped>
// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 50%;
  margin-left: 5px;
}

::v-deep .el-cascader {
  width: 100%;
  // height: 32px;
  // line-height: 32px;

  // input {
  //   height: 32px;
  //   line-height: 32px;
  // }
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
